import { adminApi, useAdminAuth } from "@/lib/adminAuth";
import { ChangePasswordForm } from "@/components/common/ChangePasswordForm";
import { ADMIN } from "@/constants/testIds";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Cuenta() {
  usePageTitle("Mi cuenta");
  const { usuario } = useAdminAuth();

  return (
    <div className="mx-auto max-w-3xl px-8 py-8">
      <h1 className="text-xl font-semibold text-[var(--tc-text)]">Mi cuenta</h1>
      <p className="mt-1 text-sm text-[var(--tc-text-secondary)]">{usuario?.nombre} · {usuario?.email}</p>

      <div className="mt-6 rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-6">
        <h2 className="text-base font-semibold text-[var(--tc-text)]">Cambiar contraseña</h2>
        <p className="mt-1 mb-4 text-sm text-[var(--tc-text-secondary)]">
          Cerramos las demás sesiones activas de tu cuenta al guardar.
        </p>
        <ChangePasswordForm
          api={adminApi}
          tokenStorageKey="tc_admin_token"
          testIds={{
            currentInput: ADMIN.cuentaCurrentPasswordInput,
            newInput: ADMIN.cuentaNewPasswordInput,
            confirmInput: ADMIN.cuentaConfirmPasswordInput,
            submitButton: ADMIN.cuentaSubmitButton,
            error: ADMIN.cuentaError,
            success: ADMIN.cuentaSuccess,
          }}
        />
      </div>
    </div>
  );
}
